import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import Main from "./pages/Main.jsx";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(<App />);
